// Functions
import VerifyToken from "../../config/verifyToken";
// Components
import Header from "../../components/header";
import { Main } from "../generalStyle";
import StickyLogo from "../../components/stickyLogo";
import SessionsView from "../../components/rgsICU/sessions";

const Sessions = () => (
  <>
    {VerifyToken()}
    <Header />
    <Main>
      <StickyLogo />
      <SessionsView />
    </Main>
  </>
);

export default Sessions;
